import React, { Fragment, useEffect, useContext } from 'react';
import Head from 'next/head';
import { Accordion, AccordionItem } from 'react-light-accordion';
import { useRouter } from 'next/router';

import DangerousHTML from './DangerousHTML';
// import appConfig from '../appConfig';

import Header from './Header';
import useSegment from '../hooks/segment';
import { setRollbarWarning } from '../helpers/rollBar';
import { useSelector } from 'react-redux';
import { useConfigData } from '../Context/ConfigProvider';

const CMSComponent = ({
  title,
  h1Title = false,
  ComponentAbove,
  metaDescription = '',
  ComponentBelow,
  className,
  html,
  friends = false,
  canonicalHref,
  testId
}) => {
  // const {
  //   state: { seoData = {} }
  // } = useContext(appContext);
  const seoData = useSelector(state => state.other.seoData) || {}
  const [prevQues, setprevQues] = React.useState('');
  const { trackEvent } = useSegment();
  const router = useRouter();
  const { pathname } = router;
  const appConfig = useConfigData();
  useEffect(() => {
    try {
      window.eval(html.script);
    } catch (error) {
      setRollbarWarning('CMSComponent.js_useEffect_catch', error);
      console.error('CMSComponent.js_useEffect_catch', error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function faqClick(question) {
    if (question != prevQues) {
      setprevQues(question);
      trackEvent('FAQ Expand', {
        category: 'FAQ',
        action: 'Expand',
        label: question
      });
    }
  }

  const { site_info: siteInfo = {} } = seoData || {};
  return (
    <Fragment>
      <Head>
        <title>{`${title} | ${siteInfo.meta_title_description || appConfig.META_TITLE_DESCRIPTION}`}</title>
        {metaDescription ? <meta name="description" content={metaDescription} /> : null}
        <link rel="canonical" href={canonicalHref} />
      </Head>
      {!friends && (
        <Header
          h1Title
          dark
          hideTabs
          showLogin={false}
          backPath
          pageName={title}
          minimalNavbar
          hasWhiteBg
          hideCartIcon
          hasShadow
          className="hide-address-bar"
        />
      )}
      <div test-id={testId} className={`cms-page container ${className}`}>
        {ComponentAbove && <ComponentAbove />}
        {html && !html.is_object ? (
          <div>{html ? <DangerousHTML html={html.description} /> : <div className="cms-page" />}</div>
        ) : null}
        {html && html.is_object ? (
          <div className=" faq">
            <Accordion>
              {JSON.parse(html.description).map(faq => (
                <div onClick={() => faqClick(faq.question)}>
                  <AccordionItem title={faq.question}>
                    <DangerousHTML html={faq.answer} />
                  </AccordionItem>
                </div>
              ))}
            </Accordion>
            {ComponentBelow && <ComponentBelow />}
          </div>
        ) : null}
      </div>
    </Fragment>
  );
};

export default CMSComponent;
